import { afterSetState, isset } from "legacy/helpers.es6"
import MapMarinaList from "legacy/map/MapMarinaList"
import MapMarinaMap from "legacy/map/MapMarinaMap"
import MapSearchFilters from "legacy/map/MapSearchFilters"
import PropTypes from "prop-types"
import React from "react"
import { v4 as uuidv4 } from "uuid"

class MapController extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      marinas: [],
      amenities: this.props.amenities,
      services: this.props.services,
      boatus: this.props.boatus,
      selectedAmenities: this.props.selectedAmenities,
      selectedServices: this.props.selectedServices,
      selectedBoatUS: this.props.selectedBoatUS,
      focusedMarina: null,
      searchOnMove: true,
      currentLat: this.props.currentLat,
      currentLon: this.props.currentLon,
      zoom: this.props.zoom,
      searchFromParams: this.props.searchFromParams,
      searchTerm: this.props.searchTerm,
      filtersHidden: true,
      processing: false,
      showingMapMobile: false,
      dock: this.props.dock,
      mooring: this.props.mooring,
      dayTrip: this.props.dayTrip,
      arrival: this.props.arrival,
      departure: this.props.departure,
      firstLoad: true,
      onlineBooking: this.props.onlineBooking,
      filters: {
        dockwaPlusDeal: this.props.dockwaPlusDeal,
        dockwaPlusFuelDiscount: this.props.dockwaPlusFuelDiscount,
      },
    }

    this.setParentState = this.setParentState.bind(this)
    this.setFilterState = this.setFilterState.bind(this)
    this.trackSearchResults = this.trackSearchResults.bind(this)
    this.mapChange = _.debounce(
      this.mapChange.bind(this),
      this.props.mapDebounce
    )
    this.marinasWillChange = this.marinasWillChange.bind(this)
    this.pushNewUrl = this.pushNewUrl.bind(this)
    this.marinaSearch = this.marinaSearch.bind(this)
    this.getUsersLocation = this.getUsersLocation.bind(this)
    this.getSpaceTypes = this.getSpaceTypes.bind(this)
    this.getLocation = this.getLocation.bind(this)
    this.hoverMarina = this.hoverMarina.bind(this)
    this.blurMarina = this.blurMarina.bind(this)
    this.showMapMobile = this.showMapMobile.bind(this)
    this.hideMapMobile = this.hideMapMobile.bind(this)
    this.navHeight = document.querySelector(".navbar-dockwa").clientHeight
    this.tabHeight = document.getElementById("pwaTabbar").clientHeight

    this.map = null
    this.setMapElementRef = (element) => {
      this.map = element
    }
  }

  componentDidMount() {
    this.mapChange()
    if (this.state.searchFromParams !== true) {
      this.getUsersLocation()
    }
  }

  setParentState(state) {
    this.setState(state)
  }

  setFilterState(filter, value) {
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [filter]: value,
        },
      }),
      this.mapChange
    )
  }

  trackSearchResults() {
    const eventProps = {
      marina_ids: this.state.marinas.map((marina) => marina.mcom_id),
      lat: this.state.currentLat,
      lon: this.state.currentLon,
      search_term: this.state.searchTerm,
      search_id: this.state.searchId,
      experience_name: "search",
    }
    Amplitude.trackEvent("search:results_shown", eventProps)
  }

  mapChange() {
    afterSetState(() => {
      const bounds = this.map.map.getBounds()
      const center = this.map.map.getCenter()
      const zoom = this.map.map.getZoom()
      let params = {
        lat: center.lat,
        lon: center.lng,
        bounding_box: {
          top_left: {
            lat: bounds._ne.lat,
            lon: bounds._sw.lng,
          },
          bottom_right: {
            lat: bounds._sw.lat,
            lon: bounds._ne.lng,
          },
        },
        amenities: this.state.selectedAmenities,
        services: this.state.selectedServices,
        boatus_discounts: this.state.selectedBoatUS,
        space_types: this.getSpaceTypes(),
        dockwa_plus_deal: this.state.filters.dockwaPlusDeal,
        dockwa_plus_fuel_discount: this.state.filters.dockwaPlusFuelDiscount,
      }

      if (this.state.onlineBooking) {
        // only send a value for this param in the request body if its present
        params = Object.assign(params, {
          online_booking: this.state.onlineBooking,
        })
      }

      this.pushNewUrl(center, zoom)
      this.marinaSearch(params)
    })
  }

  marinasWillChange(marinas) {
    if (!isset(this.state.marinas) && marinas.length > 0) {
      return true
    } else {
      return (
        !(this.state.marinas.length === marinas.length) ||
        !this.state.marinas.every(
          (marina, index) => marinas[index].id === marina.id
        )
      )
    }
  }

  pushNewUrl(center, zoom) {
    let queryString = `/search?lat=${center.lat}&lon=${center.lng}&zoom=${zoom}`

    if (isset(this.state.arrival)) {
      queryString += "&arrival=" + encodeURIComponent(this.state.arrival)
    }
    if (isset(this.state.departure)) {
      queryString += "&departure=" + encodeURIComponent(this.state.departure)
    }
    if (this.state.dock === true) {
      queryString += "&dock=" + encodeURIComponent(this.state.dock)
    }
    if (this.state.mooring === true) {
      queryString += "&mooring=" + encodeURIComponent(this.state.mooring)
    }
    if (this.state.dayTrip === true) {
      queryString += "&day_trip=" + encodeURIComponent(this.state.dayTrip)
    }
    if (this.state.selectedAmenities.length > 0) {
      queryString +=
        "&amenities=" +
        encodeURIComponent(this.state.selectedAmenities.join(","))
    }
    if (this.state.selectedServices.length > 0) {
      queryString +=
        "&services=" + encodeURIComponent(this.state.selectedServices.join(","))
    }
    if (this.state.selectedBoatUS.length > 0) {
      queryString +=
        "&boatus=" + encodeURIComponent(this.state.selectedBoatUS.join(","))
    }
    if (this.state.onlineBooking === true) {
      queryString +=
        "&online_booking=" + encodeURIComponent(this.state.onlineBooking)
    }
    if (this.state.filters.dockwaPlusDeal === true) {
      queryString += "&dockwa_plus_deal"
    }
    if (this.state.filters.dockwaPlusFuelDiscount === true) {
      queryString += "&dockwa_plus_fuel_discount"
    }
    window.history.replaceState(null, document.title, queryString)
  }

  marinaSearch(params) {
    this.setState({ processing: true })
    this.loadingid = Math.random()
    if (isset(this.state.arrival)) {
      params.check_in_date = moment(this.state.arrival, "MM/DD/YYYY").format(
        "YYYY-MM-DD"
      )
    }
    if (isset(this.state.departure)) {
      params.check_out_date = moment(this.state.departure, "MM/DD/YYYY").format(
        "YYYY-MM-DD"
      )
    }
    $.post(
      "/explore/search/map",
      params,
      function (loadingid, data) {
        if (this.loadingid === loadingid) {
          this.map.dataUpdated()
          const shouldTrack = this.marinasWillChange(data.marinas)
          this.setState({
            marinas: data.marinas,
            total_marinas: data.total_marinas,
            processing: false,
            firstLoad: false,
          })
          if (shouldTrack) {
            this.setState({
              searchId: uuidv4(),
            })
            this.trackSearchResults()
          }
        }
      }.bind(this, this.loadingid)
    ).fail(
      function (loadingid, data) {
        if (this.loadingid === loadingid) {
          this.setState({
            processing: false,
            submitError: JSON.parse(data.responseText).error,
          })
        }
      }.bind(this, this.loadingid)
    )
  }

  getUsersLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.setState({
            currentLat: position.coords.latitude,
            currentLon: position.coords.longitude,
          })
          this.map.easeMapToLocation(
            position.coords.longitude,
            position.coords.latitude
          )
          afterSetState(this.marinaSearch)
        },
        (error) => {
          console.warn("Error occurred. Error code: " + error.code)
          // error.code can be:
          //   0: unknown error
          //   1: permission denied
          //   2: position unavailable (error response from location provider)
          //   3: timed out
        },
        { timeout: 10 * 1000 }
      )
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showingMapMobile !== this.state.showingMapMobile) {
      this.map.resizeMap()
    }
  }

  getSpaceTypes() {
    const spaceTypes = []
    if (this.state.dock) {
      spaceTypes.push("Dock")
    }
    if (this.state.mooring) {
      spaceTypes.push("Mooring")
    }
    if (this.state.dayTrip) {
      spaceTypes.push("Temporary")
    }
    return spaceTypes
  }

  getLocation(data) {
    this.setState({ processing: true })
    const params = {}
    if (isset(data.google_place_id)) {
      params.google_place_id = data.google_place_id
    }
    if (isset(data.search)) {
      params.search = data.search
    }

    const urlParams = new URLSearchParams(window.location.search)
    const latitude = urlParams.get("lat")
    const longitude = urlParams.get("lon")

    if (latitude && longitude) {
      params.lat = latitude
      params.lon = longitude
    }

    $.post("/explore/location_from_autocomplete", params, (data) => {
      this.setState({ currentLat: data.lat, currentLon: data.lon })
      this.map.easeMapToLocation(data.lon, data.lat)
    }).fail(
      function (data) {
        this.setState({
          processing: false,
          submitError: JSON.parse(data.responseText).error,
        })
      }.bind(this, this.loadingid)
    )
  }

  hoverMarina(id) {
    this.setState({ focusedMarina: id })
    $("#marina-marker-" + id).addClass("focused-marina")
  }

  blurMarina() {
    this.setState({ focusedMarina: null })
    $(".marker").removeClass("focused-marina")
  }

  showMapMobile() {
    this.setState({ showingMapMobile: true })
  }

  hideMapMobile() {
    this.setState({ showingMapMobile: false })
  }

  showRightPane() {
    return this.state.showingMapMobile || window.innerWidth > 1023
  }

  containerHeight() {
    return $(window).height() - (this.navHeight + this.tabHeight) + "px"
  }

  render() {
    return (
      <div className="map-controller clearfix">
        <div
          className="left-pane"
          style={{
            height: this.containerHeight(),
            display: this.state.showingMapMobile ? "none" : "block",
          }}
        >
          <MapSearchFilters
            state={this.state}
            setParentState={this.setParentState}
            getLocation={this.getLocation}
            showMapMobile={this.showMapMobile}
            mapChange={this.mapChange}
            experienceName={this.props.experienceName}
            searchDebounce={this.props.searchDebounce}
            setFilterState={this.setFilterState}
          />
          <hr />
          <MapMarinaList
            state={this.state}
            hoverMarina={this.hoverMarina}
            blurMarina={this.blurMarina}
          />
        </div>
        <div
          className="right-pane"
          style={{
            height: this.containerHeight(),
            display: this.showRightPane() ? "block" : "none",
          }}
        >
          <MapMarinaMap
            ref={this.setMapElementRef}
            state={this.state}
            hoverMarina={this.hoverMarina}
            blurMarina={this.blurMarina}
            mapChange={this.mapChange}
            hideMapMobile={this.hideMapMobile}
            setParentState={this.setParentState}
          />
        </div>
      </div>
    )
  }
}

MapController.propTypes = {
  amenities: PropTypes.array,
  services: PropTypes.array,
  boatus: PropTypes.array,
  selectedAmenities: PropTypes.array,
  selectedServices: PropTypes.array,
  selectedBoatUS: PropTypes.array,
  currentLat: PropTypes.string,
  currentLon: PropTypes.string,
  zoom: PropTypes.number,
  searchFromParams: PropTypes.bool,
  searchTerm: PropTypes.string,
  dock: PropTypes.bool,
  mooring: PropTypes.bool,
  dayTrip: PropTypes.bool,
  arrival: PropTypes.string,
  departure: PropTypes.string,
  onlineBooking: PropTypes.bool,
  dockwaPlusDeal: PropTypes.bool,
  dockwaPlusFuelDiscount: PropTypes.bool,
  experienceName: PropTypes.string,
  searchDebounce: PropTypes.number,
  mapDebounce: PropTypes.number,
}

export default MapController
